"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterActions = void 0;
var react_1 = require("react");
var product_list_1 = require("../../../../../../api/calls/product/product_list");
var IFilterAction_1 = require("../../../../../../interfaces/IFilterAction");
var constants_1 = require("../components/constants");
var constants_2 = require("../constants");
var useAttributefilter_1 = __importDefault(require("./useAttributefilter"));
function useFilterActions(_a) {
    var _this = this;
    var products = _a.products, productAttributes = _a.productAttributes, categories = _a.categories;
    var _b = (0, react_1.useState)("ALL"), selectedStatusFilter = _b[0], setSelectedStatusFilter = _b[1];
    var _c = (0, react_1.useState)("ALL"), selectedPriceFilter = _c[0], setSelectedPriceFilter = _c[1];
    var _d = (0, react_1.useState)("ALL"), selectedChannelsFilter = _d[0], setSelectedChannelsFilter = _d[1];
    var _e = (0, react_1.useState)("ALL"), selectedAvailabilityType = _e[0], setSelectedAvailabilityType = _e[1];
    var _f = (0, react_1.useState)(false), selectedOnPromo = _f[0], setSelectedOnPromo = _f[1];
    var _g = (0, react_1.useState)([]), selectedCategory = _g[0], setSelectedCategory = _g[1];
    var attributeFilterOptions = (0, useAttributefilter_1.default)({
        productAttributes: productAttributes,
    }).filterOptions;
    var _h = (0, react_1.useState)(20000), maxFilterPrice = _h[0], setMaxFilterPrice = _h[1];
    var filters = function () {
        var uniqueStatuses = Array.from(new Set(products.map(function (product) { return product.status; })));
        var productFilters = uniqueStatuses.map(function (status) { return ({
            label: status,
            value: status.toLowerCase(),
        }); });
        return __spreadArray([{ label: "ALL", value: "ALL" }], productFilters, true);
    };
    var onSetSelectedStatusType = (0, react_1.useCallback)(function (value) {
        setSelectedStatusFilter(value);
    }, [filters]);
    var onSetSelectedAvailabilityType = (0, react_1.useCallback)(function (value) {
        setSelectedAvailabilityType(value);
    }, [filters]);
    var onSetSelectedPromo = (0, react_1.useCallback)(function (value) {
        setSelectedOnPromo(value);
    }, [filters]);
    var onChannelsFilterChange = (0, react_1.useCallback)(function (value) {
        setSelectedChannelsFilter(value);
    }, [filters]);
    var onSetSelectedCategory = (0, react_1.useCallback)(function (value) {
        setSelectedCategory(value);
    }, [filters]);
    var filterActions = (0, react_1.useMemo)(function () { return __spreadArray([
        {
            type: IFilterAction_1.FilterTypeEnum.PriceRange,
            key: "price_range",
            label: "Price",
            value: selectedPriceFilter,
            onChange: setSelectedPriceFilter,
            range: {
                min: 0,
                defaultValue: [0, maxFilterPrice],
                max: maxFilterPrice,
                step: 1,
            },
        },
        {
            key: "on_promotion",
            type: IFilterAction_1.FilterTypeEnum.Toggle,
            value: selectedOnPromo,
            onChange: onSetSelectedPromo,
            options: [
                {
                    label: "On Promotion",
                    value: false,
                },
            ],
        },
        {
            key: "categories",
            label: "Category",
            type: IFilterAction_1.FilterTypeEnum.TagGroup,
            onChange: onSetSelectedCategory,
            value: selectedCategory,
            options: categories.map(function (category) { return ({
                label: category.name,
                value: category._id,
            }); }),
        },
        {
            type: IFilterAction_1.FilterTypeEnum.CheckboxGroup,
            key: "statuses",
            label: "Status",
            value: selectedStatusFilter,
            options: constants_2.STATUS,
            onChange: onSetSelectedStatusType,
        },
        {
            key: "channels",
            type: IFilterAction_1.FilterTypeEnum.CheckboxGroup,
            label: "Channels",
            value: selectedChannelsFilter,
            options: constants_2.CHANNELS,
            onChange: onChannelsFilterChange,
        },
        {
            key: "availability",
            type: IFilterAction_1.FilterTypeEnum.RadioGroup,
            label: "Product Availability",
            value: selectedAvailabilityType,
            options: constants_1.PRODUCT_AVAILABILITY,
            onChange: onSetSelectedAvailabilityType,
        }
    ], attributeFilterOptions, true); }, [
        selectedStatusFilter,
        selectedPriceFilter,
        selectedChannelsFilter,
        selectedAvailabilityType,
        selectedOnPromo,
        selectedCategory,
        attributeFilterOptions,
        maxFilterPrice,
    ]);
    var resetFilters = function () {
        setSelectedStatusFilter("ALL");
        setSelectedChannelsFilter("ALL");
        setSelectedAvailabilityType("ALL");
        setSelectedPriceFilter("ALL");
        setSelectedOnPromo(false);
        setSelectedCategory([]);
    };
    var getMaxFilterPrice = function () { return __awaiter(_this, void 0, void 0, function () {
        var content;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, (0, product_list_1.get_product_list)({ page: 1, size: 1, sort_by: "price", order_by: "-1" })];
                case 1:
                    content = (_c.sent()).content;
                    if ((_a = content === null || content === void 0 ? void 0 : content.product_list) === null || _a === void 0 ? void 0 : _a.length) {
                        setMaxFilterPrice(parseFloat((_b = content.product_list[0]) === null || _b === void 0 ? void 0 : _b.price));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        getMaxFilterPrice();
        resetFilters();
    }, []);
    return {
        filterActions: filterActions,
    };
}
exports.useFilterActions = useFilterActions;
